// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { AllocationFactory } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/AllocationFactory';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useAllocationFactories: (
  operator: string,
  registrar: string,
) => UseQueryResult<TemplateContract<AllocationFactory>[], string> = (operator, registrar) => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOffset({
    queryKey: ['queryAllocationFactory', operator, registrar],
    queryFn: async (_, offset) => {
      return ledgerApi.queryAllocationFactory(offset, operator, registrar);
    },
  });
};

export default useAllocationFactories;
